import { MsalGuard } from "@azure/msal-angular";

import { LandingComponent } from "./landing/landing.component";
import { DetailsComponent } from "./details/details.component";
import { AnalysisReportComponent } from "./analysis-report/analysis-report.component";
import { AnalysisReportQuestionsComponent } from "./analysis-report-questions/analysis-report-questions.component";
import { AnalysisReportQuestionsDetailsComponent } from "./analysis-report-questions-details/analysis-report-questions-details.component";
import { DocumentationComponent } from "./documentation/documentation.component";

import type { Routes } from "@angular/router";

/**
 * Every route is behind MsalGuard.
 *
 * MsalGuard is used rather than a hand-rolled guard specifically because it
 * saves the requested URL before redirecting to Entra, and MSAL restores it
 * afterwards (navigateToLoginRequestUrl). A guard that redirects to a local
 * /login route instead would drop the query string — so a deep link from
 * Creator such as /analysis-report-questions?templateId=01M1BQG… would survive
 * sign-in as a bare app root, which is the failure mode this avoids.
 */
export const routes: Routes = [
  { path: "", component: AnalysisReportComponent, canActivate: [MsalGuard] },
  { path: "landing", component: LandingComponent, canActivate: [MsalGuard] },
  { path: "questions", component: LandingComponent, canActivate: [MsalGuard] },
  { path: "details/:templateId", component: DetailsComponent, canActivate: [MsalGuard] },
  {
    path: "details/:templateId/:questionId",
    component: DetailsComponent,
    canActivate: [MsalGuard],
  },
  { path: "details", component: DetailsComponent, canActivate: [MsalGuard] },
  { path: "analysis-report", component: AnalysisReportComponent, canActivate: [MsalGuard] },
  {
    path: "analysis-report-questions",
    component: AnalysisReportQuestionsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: "analysis-report-questions-details",
    component: AnalysisReportQuestionsDetailsComponent,
    canActivate: [MsalGuard],
  },
  { path: "documentation", component: DocumentationComponent, canActivate: [MsalGuard] },
  { path: "**", redirectTo: "" },
];
